const PROTOCOL_REGEX = /^(?:[a-z][a-z0-9+.-]*:)?\/\//i;
const NON_HTTP_PROTOCOL_REGEX = /^(mailto:|tel:|sms:|javascript:|data:)/i;
const FILE_EXTENSION_REGEX = /\/[^/?#]+\.[^/?#]+$/;

/**
 * Adds a trailing slash to an internal URL if it doesn't already have one.
 * External URLs, hash links, query strings, and file paths are not modified.
 */
export function addTrailingSlashToInternalUrl(url: string): string {
  const value = url.trim();

  if (
    !value ||
    value === '/' ||
    value.startsWith('#') ||
    value.startsWith('?') ||
    NON_HTTP_PROTOCOL_REGEX.test(value) ||
    PROTOCOL_REGEX.test(value) ||
    !value.startsWith('/')
  ) {
    return url;
  }

  const hashIndex = value.indexOf('#');
  const beforeHash = hashIndex >= 0 ? value.slice(0, hashIndex) : value;
  const hash = hashIndex >= 0 ? value.slice(hashIndex) : '';

  const queryIndex = beforeHash.indexOf('?');
  const pathname = queryIndex >= 0 ? beforeHash.slice(0, queryIndex) : beforeHash;
  const search = queryIndex >= 0 ? beforeHash.slice(queryIndex) : '';

  if (
    pathname === '/' ||
    pathname.endsWith('/') ||
    pathname.startsWith('/api/') ||
    FILE_EXTENSION_REGEX.test(pathname)
  ) {
    return value;
  }

  return `${pathname}/${search}${hash}`;
}
